import React from 'react'
import { Sold } from './style'

export default () => <Sold>Vendido</Sold>
